export default "__VITE_ASSET__Clo_5fU9__"